import React, { memo, useCallback, useEffect, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import PropTypes from 'prop-types';
import PositionWidget from "components/pages/stillage-collection/positions/PositionWidget";
import { getStillagePositions } from "services/stillageCollections";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const CollectionWidget = () => {
    const positionDates = {
        start: dayjs().startOf('isoWeek').toISOString(),
        end: dayjs().startOf('isoWeek').add(4, 'day').toISOString()
    };
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    const buildPositionType = useCallback((data, type) =>
        Object.keys(data).map(date => {
            const keys = Object.keys(data[date]).filter(key => key === type);
            const name = keys.join(',');
            return {
                date,
                [name]: {
                    estCount: keys.reduce((acc, key) => acc += data[date][key]?.estCount, 0),
                    actualCount: keys.reduce((acc, key) => acc += data[date][key]?.actualCount, 0),
                    totalFrames: keys.reduce((acc, key) => acc += data[date][key]?.totalFrames, 0),
                    plannedCSO: keys.reduce((acc, key) => acc += data[date][key]?.plannedCSO, 0),
                    plannedSF: keys.reduce((acc, key) => acc += data[date][key]?.plannedSF, 0),
                    actualCollected: keys.reduce((acc, key) => acc += data[date][key]?.actualCollected, 0),
                }
            }
        }), []);

    const getPositionData = useCallback(async (start, end) => {
        setLoading(true);
        getStillagePositions(start, end)
            .then(res => {
                const standard = buildPositionType(res?.counts, 'Standard');
                const aFrames = buildPositionType(res?.counts, 'stillage.aframe');
                const crane = buildPositionType(res?.counts, 'stillage.craneable');
                const specCrane = buildPositionType(res?.counts, 'stillage.special.craneable');
                setData({ standard, aFrames, crane, specCrane })
            })
            .catch((err) => {
                console.log(err);
                toast.error('Something went wrong! ', err);
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        getPositionData(positionDates.start, positionDates.end);
    }, []);

    const redirectToPositionPage = useCallback(() => window.open(`/stillages/stillage-collection`, '_blank'), []);

    return (
        <Row>{
            loading ?
                <Col xs={12} className="text-center"><Spinner variant="primary" /></Col> :
                <>
                    <Col className="cursor-pointer" xs={12} onClick={redirectToPositionPage}>
                        <PositionWidget
                            title='Standard'
                            data={data?.standard}
                            typeKey='Standard'
                        />
                    </Col>
                    <Col className="cursor-pointer" xs={12} onClick={redirectToPositionPage}>
                        <PositionWidget
                            title='A Frame'
                            data={data?.aFrames}
                            typeKey='stillage.aframe'
                        />
                    </Col>
                    <Col className="cursor-pointer" xs={12} onClick={redirectToPositionPage}>
                        <PositionWidget
                            title='Std Craneable'
                            data={data?.crane}
                            typeKey='stillage.craneable'
                        />
                    </Col>
                    <Col className="cursor-pointer" xs={12} onClick={redirectToPositionPage}>
                        <PositionWidget
                            title='Conquip'
                            data={data?.specCrane}
                            typeKey='stillage.special.craneable'
                        />
                    </Col>
                </>
        }
        </Row>
    );
}

CollectionWidget.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
};

export default memo(CollectionWidget);